<template>
  <el-dialog v-model="visible" title="品牌编辑" width="1000px" :before-close="handleClose">
    <el-form class="mr20" ref="ruleForm" :model="addRow"  label-width="130px">
        <form-item-rule label="品牌名称" prop="name">
          <el-input v-model="addRow.name"></el-input>
        </form-item-rule>
        <form-item-rule label="排序" prop="sort">
          <el-input-number :min="0" :controls="false" v-model="addRow.sort"></el-input-number>
        </form-item-rule>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="doSave()">确定</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";

export default {
  name: "brandAdd",
  components: {FormItemRule,},
  data() {
    return {
      visible: false,
      addRow: {}
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(row, type) {
      if (row) {
        this.addRow = this.copyObj(row);
      } else {
        this.addRow = {name:"",sort:0,type:type,status:0};
      }
      this.visible = true;
    },
    doSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/brand/addOrUpdate", this.addRow, () => {
            this.handleClose();
            this.$emit('load')
            this.message("操作成功");
          })
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

</style>
